/**
 * @Time    : 2022/6/4 22:21
 * @Author  : tlovet
 * @Software: WebStorm
 */

import { getTheme, setTheme } from '@/utils/localStorage';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { Segmented, Spin } from 'antd';
import React from 'react';

export const ThemeSwitch: React.FC = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  // 必须放在里面，不然再切换时，获取的值是上次的
  const navTheme: NavThemeType = getTheme();

  const loading = (
    <Spin
      size="small"
      style={{
        marginLeft: 8,
        marginRight: 8,
      }}
    />
  );

  if (!initialState) {
    return loading;
  }

  return (
    <span style={{ display: 'flex' }}>
      <Segmented
        size="small"
        shape="round"
        options={[
          { value: 'light', icon: <SunOutlined /> },
          { value: 'realDark', icon: <MoonOutlined /> },
        ]}
        value={navTheme}
        onChange={(theme: NavThemeType) => {
          setTheme(theme);
          setInitialState((preInitialState: any) => ({
            ...preInitialState,
            settings: {
              ...preInitialState?.settings,
              navTheme: theme,
            },
          }));
        }}
      />
    </span>
  );
};
